module.exports = __webpack_public_path__ + "6ab868233f0d9962678db3c17a64cad5.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-accounts/info-sharing-accounts-zh.html
// module id = 986
// module chunks = 0